import routerOptions0 from "/root/workspace/ldshop_vest/node_modules/.pnpm/nuxt@3.14.159_@types+node@20.14.11_eslint@8.57.0_ioredis@5.6.0_rollup@4.26.0_sass@1.77.6_typescript@5.5.3_vite@5.4.11/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}